import { createSlice } from '@reduxjs/toolkit'

import { NOTETAKER_SETTINGS_PATH } from 'shared/constants/personal_browser_urls'

const DEFAULT_REDIRECT_DESTINATION = NOTETAKER_SETTINGS_PATH

const loadingModalSlice = createSlice({
  name: 'loadingModal',
  initialState: {
    showAcknowledgementLoadingModal: false,
    showRecordingRulesLoadingModal: false,
    acknowledgementRedirectDestination: DEFAULT_REDIRECT_DESTINATION,
  },
  reducers: {
    closeLoadingModal: (state) => {
      state.showAcknowledgementLoadingModal = false
      state.showRecordingRulesLoadingModal = false
      state.acknowledgementRedirectDestination = DEFAULT_REDIRECT_DESTINATION
    },
    setAcknowledgementRedirectDestination: (state, action) => {
      state.acknowledgementRedirectDestination = action.payload
    },
    showAcknowledgementLoadingModal: (state) => {
      state.showAcknowledgementLoadingModal = true
    },
    showRecordingRulesLoadingModal: (state) => {
      state.showRecordingRulesLoadingModal = true
    },
  },
})

export const {
  reducer,
  actions: {
    closeLoadingModal,
    setAcknowledgementRedirectDestination,
    showAcknowledgementLoadingModal,
    showRecordingRulesLoadingModal,
  },
} = loadingModalSlice
